import style from "./TableHead.module.scss";

export function TableHead() {
    return (
        <div className={style.head}>
            <div>Дата</div>
            <div>Тег</div>
            <div>Сума витрат</div>
            <div>Курс</div>
        </div>
    )
}